export const pl = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Wstecz",
        save: "Zapisz",
        saved: "Zapisano",
        cancel: "Anuluj",
        close: "Zamknij",
        accessDenied: "Dostęp zabroniony",
        noExportPermission: "Nie masz uprawnień do eksportu danych tego samochodu.",
        delete: "Usuń",
        downgrade: "Obniżenie",
        downgradeConfirm: "Czy na pewno chcesz przejść na plan darmowy?",
        edit: "Edytuj",
        loading: "Ładowanie...",
        confirm: "Potwierdź",
        processing: "Przetwarzanie...",
        history: "Historia",
        currentCar: "Aktualny Samochód",
        purchasedCarTitle: "Zakup Samochodu",
        initialCost: "Koszt Początkowy",
        done: "Gotowe",
        ok: "OK",
        error: "Błąd",
        errorSaving: "Błąd podczas zapisywania danych",
        mandatoryFieldsError: "Proszę poprawnie wypełnić wszystkie pola obowiązkowe.",
        search: "Szukaj",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Nieprawidłowy format e-maila",
        today: "Dziś",
        car: "Samochód",
        all: "Wszystkie",
        deleteConfirm: "Usuń",
        unsavedChangesTitle: "Nie zapisane zmiany",
        unsavedChangesMessage: "Czy chcesz zapisać zmiany przed wyjściem?",
        dontSave: "Nie zapisuj",
        additionalOptions: "Dodatkowe opcje",
        add: "Dodaj",
        fileTooLarge: "Plik jest zbyt duży. Maksymalny rozmiar to {limit} MB.",
        storageFull: "Limit pamięci został przekroczony. Maksymalna pamięć to {limit} MB.",
        dailyUploadLimit: "Osiągnięto dzienny limit przesyłania ({limit} plików/dzień). Spróbuj ponownie jutro.",
        hourlyUploadLimit: "Osiągnięto godzinny limit przesyłania ({limit} plików/godzinę). Spróbuj ponownie za godzinę.",
        fileCountLimit: "Maksymalnie {limit} plików dozwolonych na przedmiot.",
        emailParseLimitReached: "Osiągnięto limit przetwarzania e-maili. Proszę zaktualizować plan lub przetworzyć ręcznie.",
        emailLimitText: "Osiągnięto limit przetwarzania e-maili.",
        monthlyEmailScans: "Miesięczne skany e-maili",
        lifetimeEmailScans: "Całkowite skany e-maili",
        monthlyFileScans: "Miesięczne skany paragonów",
        lifetimeFileScans: "Całkowite skany paragonów",
        fileLimitText: "Osiągnięto limit skanowania paragonów.",
        planFreeTier: "Plan darmowy",
        planProTier: "Plan Pro",
        uploadFailed: "Przesyłanie nie powiodło się",
        attachments: "Załączniki",
        limitsAndUsage: "Limity i Użytkowanie",
        addresses: "adresy",
        emailCopied: "Adres e-mail skopiowany!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Wliczone",
        proOnly: "Tylko PRO",
        month: "mies.",
        openInNewTab: "Otwórz w nowej karcie",
        menu: "Menu",
        home: "Start",
        monthsShort: {
            0: "Sty",
            1: "Lut",
            2: "Mar",
            3: "Kwi",
            4: "Maj",
            5: "Cze",
            6: "Lip",
            7: "Sie",
            8: "Wrz",
            9: "Paź",
            10: "Lis",
            11: "Gru",
        },
    },
    carMetadata: {
        bodyType: "Typ nadwozia",
        drivetrain: "Napęd",
        transmission: "Skrzynia biegów",
        bodyTypes: {
            sedan: "Sedan",
            hatchback: "Hatchback",
            wagon: "Kombi",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupé",
            convertible: "Kabriolet",
            pickup: "Pickup",
            van: "Van / Minivan",
            commercial: "Komercyjny",
            other: "Inny",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Inne",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manualna",
            automatic: "Automatyczna",
            cvt: "CVT",
            other: "Inne",
        },
        otherLabel: "Inne (określ)",
        mileageLabel: "Przebieg",
    },
    auth: {
        welcome: "Witamy",
        welcomeBack: "Witamy ponownie",
        signIn: "Zaloguj się",
        signInWithGoogle: "Zaloguj się przez Google",
        signOut: "Wyloguj się",
        magicLinkDesc: "Odbierz magiczny link w swoim e-mailu",
        magicLinkSent: "Magiczny link wysłany!",
        magicLinkCheckEmail: "Sprawdź swój e-mail i kliknij link, aby się zalogować.",
        emailAddress: "Adres e-mail",
        getMagicLink: "Odbierz magiczny link",
        sending: "Wysyłanie...",
        linkSent: "Link wysłany",
        orContinueWith: "Lub kontynuuj z",
        googleAccount: "Konto Google",
        newUserNote: "Nowy tutaj? Twoje konto zostanie automatycznie utworzone po pierwszym udanym logowaniu.",
        magicLinkError: "Nie udało się wysłać magicznego linku. Proszę sprawdzić swój e-mail i spróbować ponownie.",
        genericError: "Wystąpił błąd. Proszę spróbować ponownie.",
        projectDescription: "Śledź koszty, konserwację i historię swojego samochodu w jednym miejscu.",
        loginError: "Nie można się zalogować",
        loggingIn: "Logowanie...",
        authenticating: "Uwierzytelnianie...",
        authenticatingDesc: "Proszę czekać, podczas gdy zabezpieczamy Twoją sesję.",
    },
    settings: {
        title: "Ustawienia",
        systemPreferences: "Preferencje systemowe",
        appSettings: "Ustawienia aplikacji",
        dangerZone: "Strefa zagrożenia",
        theme: "Motyw",
        language: "Język interfejsu",
        currency: "Waluta",
        units: "Jednostki",
        distanceUnit: "Jednostka odległości",
        volumeUnit: "Jednostka objętości",
        expenseTypes: "Typy wydatków",
        expenseTypesDesc: "Zarządzaj kategoriami",
        categories: "Kategorie",
        exportData: "Eksportuj dane",
        exportDesc: "Pobierz szczegółowy CSV",
        importData: "Importuj dane",
        importDesc: "Przywróć z kopii zapasowej CSV",
        deleteAccount: "Usuń konto",
        deleteAccountDesc: "Trwale usuń wszystkie dane",
        enableSync: "Włącz synchronizację",
        enableSyncDesc: "Synchronizuj dane między urządzeniami",
        account: "Konto",
        accountPlan: "Plan konta",
        carsUsage: "Samochody",
        carsLimitReached: "Osiągnięto limit samochodów",
        storageSize: "Rozmiar pamięci",
        emailScans: "Skany e-maili",
        fileScans: "Skany paragonów",
        plans: "Plany",
        currentlyPlan: "Obecnie",
        upgradePlan: "Ulepsz",
        manageSubscription: "Zarządzaj subskrypcją",
        nextPayment: "Następna płatność",
        endsOn: "Kończy się",
        adminConsole: "Konsola administratora",
        systemControl: "Kontrola systemu",
        customCategories: "Własne kategorie i etykiety",
        interfaceTheme: "Motyw interfejsu",
        light: "Jasny",
        dark: "Ciemny",
        timezone: "Strefa czasowa",
        timezoneDesc: "Używana do zaplanowanych przypomnień e-mail",
        timeFormat: "Format czasu",
        timeFormat24h: "24-godzinny (14:30)",
        timeFormat12h: "12-godzinny (2:30 PM)",
        kilometers: "kilometry (km)",
        miles: "mile (mi)",
        liters: "litry (l)",
        gallons: "galony (gal)",
        accountManagement: "Zarządzanie kontem",
        contactUs: "Skontaktuj się z nami",
        contactDesc: "W przypadku sugestii, próśb o funkcje i pytań",
        logOut: "Wyloguj się",
        logOutConfirmTitle: "Wyloguj się",
        logOutConfirmMessage: "Czy na pewno chcesz się wylogować z konta?",
        keepAccount: "Zachowaj konto",
        deleteAccountConfirmTitle: "Usuń konto",
        deleteAccountConfirmMessage: "Czy na pewno chcesz trwale usunąć swoje konto i wszystkie powiązane dane samochodowe? Ta akcja nie może być cofnięta.",
        deletePermanently: "Usuń trwale",
        deleting: "Usuwanie...",
        contactSupport: "Skontaktuj się z pomocą",
        messageSent: "Wiadomość wysłana!",
        feedbackThanks: "Dziękujemy za Twoją opinię. Doceniamy Twoje uwagi i zajmiemy się nimi.",
        backToSettings: "Powrót do ustawień",
        subjectLabel: "Temat",
        messageLabel: "Wiadomość",
        subjectPlaceholder: "O co chodzi?",
        messagePlaceholder: "Powiedz nam o swojej sugestii, prośbie o funkcję lub pytaniu...",
        enterSubjectAlert: "Proszę wprowadzić temat",
        enterMessageAlert: "Proszę wprowadzić wiadomość",
        sendFailedAlert: "Nie udało się wysłać wiadomości. Proszę spróbować ponownie później.",
    },
    export: {
        title: "Eksportuj dane",
        generatePDF: "Generuj PDF",
        carInformation: "Informacje o samochodzie",
        editInfo: "Edytuj poniższe informacje, aby dostosować swój eksport",
        editInfoHint: "Możesz usunąć lub zmodyfikować dowolne pola, których nie chcesz uwzględniać",
        filters: "Filtry",
        expenseTypes: "Typy wydatków",
        includeNotes: "Uwzględnij notatki",
        includeImages: "Uwzględnij pliki",
        hideDisabled: "Ukryj wyłączone elementy",
        itemsCount: "{total} elementów, {selected} wybranych",
        selectAll: "Zaznacz wszystko",
        deselectAll: "Odznacz wszystko",
        expenses: "Wydatki",
        notes: "Notatki",
        spareParts: "Części zamienne",
        images: "Obrazy",
        files: "Pliki",
        summary: "Podsumowanie",
        totalExpenses: "Łączne wydatki",
        totalItems: "Łączna liczba elementów",
        generatedOn: "Wygenerowano w dniu",
        noItemsSelected: "Nie wybrano żadnych elementów do eksportu",
        noItemsAvailable: "Brak elementów do eksportu",
        generating: "Generowanie PDF...",
        downloadPDF: "Pobierz PDF",
        pdfFileName: "{carName}_eksport_{date}.pdf",
        reportTitle: "Raport wydatków samochodowych",
        exportButton: "Eksportuj",
        generateCSV: "Generuj CSV",
        formatSelectorTitle: "Wybierz format",
        formatSelectorMsg: "Proszę wybrać format eksportu",
        proFeatureExportTitle: "Funkcja Pro: Eksport danych",
        proFeatureExportDesc: "Przejdź na PRO, aby eksportować historię swojego samochodu do PDF.",
        exportRestrictedPopup: "Eksport danych jest dostępny tylko dla użytkowników Pro.",
        allTypes: "Wszystkie typy",
        statistics: "Statystyki",
        driven: "Przejechane",
        since: "Od",
        averageCost: "Średni koszt",
        perKm: "za km",
        perMile: "za milę",
        period: "Okres",
        dateFrom: "Od",
        dateTo: "Do",
        allTime: "Wyczyść filtr",
        periodHint: "Jeśli nie wybrano okresu — wyświetlane są wszystkie wydatki",
        noExpenses: "Brak wydatków pasujących do filtrów",
        expensesSection: "Wydatki",
        attachmentsSection: "Załączniki",
        imagesCount: "{count} obrazów",
        pdfsCount: "{count} PDF-ów",
        includeParts: "Uwzględnij części zamienne",
        pageLabel: "Strona",
    },
    expenses: {
        title: "Wydatki",
        newExpense: "Nowy wydatek",
        editExpense: "Edytuj wydatek",
        openExpense: "Otwórz wpis wydatku",
        details: "Szczegóły wydatku",
        selectType: "Wybierz typ",
        selectTypePlaceholder: "Wybierz typ wydatku...",
        shortDescriptionPlaceholder: "Krótki opis...",
        expenseTitle: "Tytuł",
        logEntryTitleLabel: "Tytuł wpisu (Opcjonalnie)",
        defaultTitlePlaceholder: "Domyślny tytuł - {type}",
        autoTitlePlaceholder: "Zostanie automatycznie wypełnione na podstawie wybranych typów",
        carDataTitle: "Dane samochodu",
        defaultTitlePrefix: "Domyślny tytuł będzie -",
        addAnother: "Dodaj inny typ wydatku",
        addAnotherHint: "Jeśli ten wpis obejmuje wiele typów wydatków, możesz dodać je wszystkie tutaj, aby zapewnić dokładne statystyki.",
        carValueDescription: "Szacunkowa wartość rynkowa samochodu w tym momencie.",
        type: "Typ",
        date: "Data",
        amount: "Kwota",
        totalAmount: "Łącznie",
        splitCosts: "Podzielić koszty?",
        combineCosts: "Połącz koszty",
        amountWork: "Praca",
        amountParts: "Części",
        mileage: "Przebieg",
        carValue: "Wartość samochodu",
        description: "Opis",
        detailedDescription: "Szczegółowy opis",
        electricity: "Elektryczność",
        fuelType: "Typ paliwa",
        fuelTypeOptions: {
            petrol: "Benzyna",
            diesel: "Diesel",
            lpg: "LPG",
            electricity: "Elektryczność",
        },
        carData: "Dane samochodu",
        images: "Pliki",
        addImages: "Dodaj pliki",
        addImagesPDFs: "Dodaj obrazy lub PDF-y",
        deleteExpense: "Usuń wydatek",
        deleteConfirm: "Czy na pewno chcesz usunąć ten wydatek?",
        saveSuccess: "Wydatek zapisany pomyślnie",
        thisExpense: "Ten wydatek",
        stats: {
            annual: "Rocznie",
            allTime: "Wszystkie czasy",
            avgMonth: "Śr./Miesiąc",
            costPer: "Koszt/",
            noExpenses: "Brak wydatków",
            dragToReorder: "Przeciągnij uchwyt, aby zmienić kolejność",
        },
        expensesFound: "Utworzone",
        noExpensesFound: "Nie znaleziono wydatków.",
        noDescription: "Brak opisu",
        imagesCount: "Obrazy ({count})",
        deleteImageTitle: "Usuń obraz",
        deleteImageConfirm: "Czy na pewno chcesz usunąć ten obraz? Ta akcja nie może być cofnięta.",
        typeLabels: {
            fuel: "Paliwo",
            car_wash: "Mycie",
            repairs: "Naprawy",
            maintenance: "Konserwacja",
            parts: "Części zamienne",
            insurance: "Ubezpieczenie",
            inspection: "Inspekcja",
            tyres: "Opony",
            parking: "Parking",
            electricity: "Elektryczność",
            taxes: "Podatki",
            other: "Inne",
            info: "Informacje",
            service_maintenance: "Konserwacja",
            service_repair: "Naprawa",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Serwis",
            selectSubtype: "Wybierz typ usługi",
            maintenance: "Konserwacja",
            repair: "Naprawa",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Powtarzający się wydatek",
        repeatToggle: "Powtarzaj ten wydatek",
        repeatFrequency: "Częstotliwość",
        monthly: "Miesięcznie",
        startDate: "Data rozpoczęcia",
        nextDate: "Następny wpis zostanie wygenerowany",
        endDate: "Data zakończenia",
        noEndDate: "Brak daty zakończenia",
        copyOptions: "Opcje kopiowania",
        copyTitle: "Kopiuj tytuł rekordu",
        copyLocation: "Kopiuj lokalizację",
        copyDescription: "Kopiuj opis",
        active: "Aktywny",
        status: "Status",
        managedByRepeat: "Ten wydatek jest częścią powtarzającej się sekwencji.",
        placeholder: "Tutaj możesz ustawić automatyczne powtarzanie tego wydatku, jeśli występuje regularnie w tej samej kwocie.",
        deleteRepeat: "Usuń powtarzanie",
        deleteRepeatConfirm: "Czy na pewno chcesz zatrzymać i usunąć tę powtarzającą się sekwencję? Przyszłe wpisy nie będą generowane. Przeszłe wpisy pozostaną.",
        relatedEntries: "Wpisy w tej sekwencji",
        stopRepeat: "Zatrzymaj powtarzanie",
        isRepeating: "Powtarzający się",
        noTerm: "Na czas nieokreślony",
        until: "Ostatni wpis zostanie wygenerowany",
        summaryCopy: "System skopiuje",
        simulate: "Symuluj generację następnego wpisu",
        simulateSuccess: "Pomyślnie zasymulowano generację następnego wpisu",
        simulateNoDate: "Brak więcej dat do wygenerowania (osiągnięto datę końcową)",
    },
    onboarding: {
        title: "Ustaw profil",
        welcome: "Witaj!",
        subtitle: "Dostosuj swoje doświadczenie jazdy.",
        currency: "Waluta",
        preferredCurrency: "Preferowana waluta",
        distUnit: "Jednostka odległości",
        volUnit: "Jednostka objętości",
        complete: "Zakończ konfigurację",
    },
    cars: {
        unitChangeWarningTitle: "Ostrzeżenie o zmianie jednostki",
        unitChangeWarningMessage: "Zmiana tych jednostek nie przekonwertuje Twoich istniejących danych. Wszystkie historyczne rekordy pozostaną dokładnie takie, jak wprowadzono.",
        unitChangeWarningConfirm: "Zrozumiano",
        title: "Garaż",
        carAdmins: "Administratorzy samochodu",
        sharedWithMe: "Udostępnione dla mnie",
        manageAdmins: "Zarządzaj administratorami",
        adminEmail: "Email administratora",
        addAdmin: "Dodaj administratora",
        addAdminPlaceholder: "np. przyjaciel@email.com",
        removeAdmin: "Usuń",
        removeAdminConfirm: "Czy na pewno chcesz usunąć tego administratora?",
        adminAdded: "Administrator dodany",
        adminRemoved: "Administrator usunięty",
        removeMyAccess: "Usuń moje uprawnienia",
        removeMyAccessConfirm: "Czy na pewno chcesz zrezygnować z dostępu do tego samochodu?",
        myAccessRemoved: "Dostęp usunięty",
        noAdminsYet: "Nie dodano jeszcze administratorów.",
        adminInfoText: "Administratorzy mogą dodawać i edytować wydatki, notatki oraz części zamienne, ale nie mogą usunąć samego samochodu.",
        newCar: "Dodaj Samochód",
        carNotFound: "Samochód Nie Znaleziony",
        carNotFoundDesc: "Żądany samochód nie istnieje lub nie masz do niego dostępu.",
        accessDenied: "Dostęp Zabroniony",
        accessDeniedDesc: "Ten samochód jest prywatny i niedostępny publicznie.",
        backToHome: "Powrót do Strony Głównej",
        adminRestricted: "Dostęp Ograniczony",
        adminRestrictedDesc: "Tylko upoważnieni administratorzy mogą uzyskać dostęp do tej konsoli. Proszę wrócić do głównej aplikacji.",
        returnHome: "Powrót do Strony Głównej",
        editCar: "Edytuj Samochód",
        name: "Nazwa Samochodu",
        model: "Model",
        year: "Rok",
        plate: "Numer Rejestracyjny",
        vin: "Numer VIN",
        mileage: "Aktualny Przebieg",
        initialMileage: "Początkowy Przebieg",
        engineType: "Typ Silnika",
        tapToChangeIcon: "Stuknij, aby zmienić ikonę",
        chooseIcon: "Wybierz Ikonę",
        imageTab: "Obraz",
        iconTab: "Ikona",
        chooseColor: "Wybierz Kolor",
        chooseEmoji: "Wybierz Emoji",
        uploadImage: "Prześlij Obraz",
        clickToBrowse: "Kliknij, aby przeszukać pliki",
        currentCarIcon: "Aktualna ikona samochodu",
        changeImage: "Zmień Obraz",
        zoom: "Powiększ",
        rotate: "Obróć",
        removeChangeImage: "Usuń / Zmień Obraz",
        selectIcon: "Wybierz Ikonę",
        cropAndSave: "Przytnij i Zapisz",
        displayName: "Nazwa Wyświetlana",
        displayNamePlaceholder: "np. Mój Samochód na Weekend",
        makeLabel: "Marka *",
        modelLabel: "Model *",
        yearLabel: "Rok *",
        fuelTypeLabel: "Typ Paliwa *",
        licensePlateLabel: "Tablica Rejestracyjna",
        vinLabel: "VIN",
        notesLabel: "Notatki (opcjonalnie)",
        notesPlaceholder: "np. 1.6 TDI, 85kW, 1588cc, bateria 62kWh, AWD, itp.",
        publicAccess: "Uczyń samochód publicznie dostępnym",
        publicAccessDesc: "Inni mogą przeglądać ten samochód za pomocą udostępnionego linku",
        shareLocations: "Zezwól na wyświetlanie również dodanych lokalizacji",
        shareLocationsDesc: "Włącz to, aby uczynić lokalizacje samochodów widocznymi w widoku publicznym",
        deleteCar: "Usuń Samochód",
        deleteCarTitle: "Usuń Samochód",
        deleteCarConfirm: "Czy na pewno chcesz usunąć '{name}'? Ta akcja nie może być cofnięta.",
        noCars: "Brak samochodów w Twoim garażu",
        addFirstCarNote: "Rozpocznij swoją podróż, dodając swoje pierwsze pojazd do śledzenia wydatków.",
        addVehicle: "Dodaj Pojazd",
        myVehicles: "Moje Pojazdy",
        favorites: "Ulubione",
        deleteConfirm: "Czy na pewno chcesz usunąć ten samochód? Wszystkie powiązane wydatki zostaną usunięte.",
        deleteFailed: "Nie udało się usunąć samochodu",
        saveFailed: "Nie udało się zapisać danych samochodu",
        adminActions: "Akcje Administratora",
        importCsv: "Importuj CSV",
        clearData: "Wyczyść Dane",
        distanceUnitLabel: "Jednostka Dystansu",
        volumeUnitLabel: "Jednostka Objętości",
        currencyLabel: "Waluta",
        boughtAt: "Data Zakupu",
        purchasePrice: "Cena Zakupu",
        purchaseMileage: "Przebieg przy Zakupie",
        createPurchaseRecord: "Automatycznie utwórz rekord historii zakupu",
        makePlaceholder: "np. BMW",
        modelPlaceholder: "np. X5",
        platePlaceholder: "np. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Ta informacja utworzy początkowy rekord 'Informacje' w Twojej historii z określonymi danymi.",
        availableTypes: "Dostępne Typy",
        dragToReorder: "Przeciągnij, aby zmienić kolejność",
        requestTypeNote: "Jeśli potrzebujesz innego typu - ",
        requestTypeAction: "daj nam znać!",
        emailProcessingTitle: "Przetwarzanie E-maili",
        emailInstructions: "Prześlij swoje paragony na poniższy adres. Wyodrębnimy dane i automatycznie utworzymy wydatki.",
        recentEmails: "Otrzymane E-maile",
        viewAllEmails: "ZOBACZ WSZYSTKIE ({count})",
        noEmailsReceived: "Nie otrzymano jeszcze żadnych e-maili.",
        analysisResult: "Wynik Analizy",
        vehicleInfo: "Informacje o Pojeździe",
        preferences: "Preferencje",
        purchaseHistory: "Historia Zakupu",
        emailProcessing: "Przetwarzanie E-maili",
        publicAccessTitle: "Dostęp Publiczny",
        expenseTypesTitle: "Typy Wydatków",
        adminActionsTitle: "Akcje Administratora",
        enterPurchaseDateAlert: "Proszę wprowadzić datę zakupu",
        allowedSenderEmails: "Dozwolone E-maile Nadawców",
        allowedEmailsDesc: "Dodaj adresy e-mail, które są dozwolone do wysyłania paragonów do tego samochodu. Maksymalnie 5 adresów.",
        noAllowedEmails: "Nie dodano żadnych dozwolonych e-maili.",
        emailAlreadyAdded: "Ten e-mail jest już dozwolony dla tego samochodu.",
        maxAllowedEmailsReached: "Osiągnięto maksymalny limit dozwolonych e-maili.",
        addAllowedEmailPlaceholder: "Dodaj dozwolony e-mail...",
        ownerEmail: "Właściciel",
        onlyOwner: "tylko właściciel",
        defaultAllowed: "Zawsze dozwolone",
        carLimitReachedTitle: "Osiągnięto Limit Samochodów",
        carLimitReachedMessage: "Twój plan {plan} pozwala na {limit} samochodów. Już masz {current}. Przejdź do ustawień, aby zobaczyć swoje limity lub skontaktuj się z nami, aby zaktualizować.",
        carLimitGoToSettings: "Przejdź do Ustawień",
        archivedCars: "Zarchiwizowane",
        archiveCar: "Zarchiwizuj samochód",
        unarchiveCar: "Przywróć samochód",
        sellDate: "Data sprzedaży",
        sellPrice: "Cena sprzedaży",
        sellMileage: "Przebieg sprzedaży",
        archiveConfirm: "Czy na pewno chcesz zarchiwizować ten samochód?",
        archiveInstructions: "Zarchiwizowanie samochodu oznacza, że nie jest już twój lub nie zajmujesz się nim. Proszę podać szczegóły sprzedaży do statystyk. Sprawi to, że samochód stanie się tylko do odczytu. Pola poniżej mogą być nadal edytowane później.",
        archivedBadge: "Zarchiwizowane",
        saleDetails: "Szczegóły sprzedaży",
        saleDetailsNote: "Szczegóły sprzedaży są używane do statystyk. Możesz je zaktualizować, jeśli zajdzie taka potrzeba.",
        archiveDetailsNotFillable: "Proszę wypełnić wszystkie pola, aby zarchiwizować samochód",
        emailAddressWillBeAvailableAfterSave: "Adres e-mail będzie dostępny po zapisaniu samochodu.",
        proFeatureAdminTitle: "Funkcja Pro: Administratorzy samochodów",
        proFeatureAdminDesc: "Dodaj innych użytkowników, którzy mogą przeglądać i zarządzać danymi tego samochodu.",
        proFeatureEmailTitle: "Funkcja Pro: Dodatkowi nadawcy",
        proFeatureEmailDesc: "Dodaj inne dozwolone adresy e-mail, z których mogą być wysyłane paragony do tego samochodu.",
        estimatedMileage: "Szacowany przebieg",
        summaryFrequencyLabel: "Częstotliwość podsumowania",
        summaryFrequencyOptions: {
            none: "Wyłączone",
            monthly: "Miesięcznie",
            semiAnnually: "Co pół roku",
            annually: "Rocznie",
        },
        healthProfilePrompt: "Uzupełnij swój profil zdrowotny, aby uzyskać dokładną analizę!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Benzyna",
        diesel: "Diesel",
        hybrid: "Hybrydowy",
        electric: "Elektryczny",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Trend przebiegu",
        title: "Statystyki",
        allYears: "Wszystkie lata",
        totalSpent: "Łącznie wydane",
        spentIn: "Wydane w {year}",
        perMonth: "na miesiąc",
        overall: "całościowo",
        vsPrev12m: "vs poprz. 12m",
        rolling12m: "Ostatnie 12m",
        byType: "Według typu",
        byMonth: "Według miesiąca",
        byYear: "Według roku",
        noData: "Brak danych na ten rok",
        mostExpensive: "Najdroższe",
        top: "Najlepsze",
        untitled: "Bez tytułu",
        assetAnalysis: "Analiza wartości i kosztów aktywów",
        burnNote: "* 'Całkowity koszt' obejmuje zarówno wydane pieniądze, jak i szacowany spadek wartości samochodu.",
        carMarketValue: "Wartość rynkowa samochodu",
        cumulativeCosts: "Koszty skumulowane",
        totalBurn: "Całkowity koszt (Koszty + Amortyzacja)",
        entries: "pozycje",
        avgPrice: "Średnia cena",
        consumption: "Zużycie",
        price: "Cena",
        fuelPriceTrend: "Trend cen paliw",
        spendingTrend: "Trend wydatków",
        costPerKmTrend: "Koszt za 1 km",
        costPerMileTrend: "Koszt za 1 milę",
        serviceTrendsTitle: "Trendy Serwisowe",
        expensesOnMap: "Wydatki na mapie",
        visitsCountLabel: "wizyty",
        locationsSummary: "Podsumowanie lokalizacji",
        locationsCountLabel: "miejsca",
        noLocationsFoundTitle: "Brak lokalizacji",
        noLocationsFoundDesc: "Dodaj lokalizacje do swoich zapisów, aby zobaczyć je na mapie.",
        addMileageData: "Dodaj przebieg",
        missingMileageInfo: "Niewystarczające dane do obliczenia kosztu na odległość. Dodaj przynajmniej 2 odczyty przebiegu w tym okresie (lub jeden przed tym okresem).",
        mileageModal: {
            title: "Dodaj brakujący przebieg",
            description: "Aby dokładnie obliczyć koszty na odległość dla {year}, musimy znać przebieg na początku i końcu roku.",
            startOfYear: "Początek roku (1 stycznia)",
            endOfYear: "Koniec roku (31 grudnia)",
            currentMileage: "Aktualny przebieg",
            placeholder: "Wprowadź przebieg...",
            save: "Zapisz dane",
            foundNearby: "Znaleziono w pobliżu ({date}): {value} {unit}",
            useExisting: "Użyj tego",
        },
        proAnalysis: "Analiza Pro",
        detailedAnalysis: "Szczegółowa analiza",
        upgradeToSee: "Przejdź na wyższy plan, aby zobaczyć →",
    },
    tabs: {
        dashboard: "Panel",
        expenses: "Wydatki",
        stats: "Statystyki",
        locations: "Lokalizacje",
        gallery: "Pliki",
        parts: "Części",
        notes: "Notatki",
        repair: "Tryb naprawy",
        'repair-switch': "Przełącznik samochodu",
    },
    repairAnalysis: {
        title: "Analiza decyzji naprawy",
        ownershipLength: "Czas posiadania",
        currentValue: "Aktualna wartość",
        valueOutdated: "Wartość może być nieaktualna",
        addValueToEnable: "Dodaj aktualną wartość samochodu, aby włączyć analizę",
        totalInvested: "Łącznie zainwestowane",
        totalInvestedSub: "Cena zakupu + naprawy",
        totalExcludesFuel: "nie obejmuje paliwa / energii",
        fuelLabelFuelOnly: "Całkowite paliwo",
        fuelLabelEnergyOnly: "Całkowita energia",
        fuelLabelHybrid: "Całkowite paliwo i energia",
        fuelTypeFuel: "paliwo",
        fuelTypeEnergy: "energia",
        fuelTypeHybrid: "paliwo i energia",
        fuelTotalLabel: "Łącznie paliwo/energia:",
        projectionMode: "Tryb projekcji",
        projectionModes: {
            lastYear: "Na podstawie ubiegłego roku",
            average: "Średnia historyczna",
            trend: "Trend (liniowy)",
        },
        brakeAssumption: "Utrzymanie obejmuje szacowany 3-letni cykl hamulcowy",
        repairBuffer: "Zawiera bufor ryzyka naprawy na podstawie wieku",
        yearLabel: "rok",
        totalInvestedDesc: "Cena zakupu + wszystkie naprawy",
        repairToValue: "Naprawa do wartości (12m)",
        repairToValueExplain: "Naprawy €{cost} w porównaniu do wartości samochodu €{value}. Poniżej 20% jest zdrowe; powyżej 50% to wysokie ryzyko.",
        ownershipPressure: "Presja posiadania",
        ownershipPressureExplain: "Całkowita presja kosztów: naprawy €{cost} + utrata wartości w porównaniu do €{value}. Powyżej 35% sygnalizuje stres finansowy.",
        investmentGap: "Luka inwestycyjna",
        investmentGapExplain: "Całkowita zainwestowana kwota €{invested} minus aktualna wartość €{value}. To pokazuje, ile 'straciłeś' na posiadaniu do tej pory.",
        investmentGapDesc: "Całkowita zainwestowana - aktualna wartość",
        repairExpenses12m: "Koszt naprawy 12m",
        calculatedYearlyMileage: "Obliczone roczne przebiegi: {km} km",
        calculatedYearlyRepairs: "Obliczone roczne naprawy: {amount}",
        set: "Ustaw",
        plannedRepairCost: "Planowany koszt naprawy",
        whatIfTitle: "Co jeśli wydasz {amount} teraz?",
        updatedScore: "Zaktualizowany wynik",
        updatedVerdict: "Zaktualizowany werdykt",
        howIsItCalculated: "Jak to jest obliczane?",
        usedLifespan: "Używane: {usage}% oczekiwanej żywotności",
        remainingLifespan: "Pozostało: ~{km} km",
        estimatedLifespan: "Szacowana żywotność: {km} km",
        lifecycle_stage_early: "Wczesny etap życia – niskie ryzyko poważnych awarii",
        lifecycle_stage_mid: "Średni etap życia – normalne zużycie",
        lifecycle_stage_late: "Późny etap życia – zwiększone ryzyko napraw",
        lifecycle_stage_end: "Koniec oczekiwanej żywotności – wysokie ryzyko poważnych napraw",
        calculationExplanation: "Analiza wykorzystuje cenę zakupu twojego pojazdu, ostatnie koszty napraw i szacowaną aktualną wartość, aby obliczyć wynik zdrowia finansowego. Wysokie koszty napraw w porównaniu do wartości samochodu lub szybka amortyzacja obniżą wynik.",
        confidenceLabel: "Pewność",
        confidenceLevel: {
            high: "Wysoka",
            medium: "Średnia",
            low: "Niska",
        },
        mentalFactorsTitle: "Popraw dokładność dzięki swojemu doświadczeniu",
        mentalFactorsCTA: "Szybka kontrola (30 sek)",
        mentalFactorsSurveyTitle: "Twoje doświadczenie",
        mentalFactorsSurveyDesc: "Odpowiedz na 3 szybkie pytania, aby spersonalizować swój wynik.",
        q1: "Czy Twój samochód spełnia Twoje potrzeby?",
        q1Help: "Przestrzeń, komfort, funkcje",
        q2: "Czy lubisz prowadzić swój samochód?",
        q2Help: "Wygląd, komfort, odczucia",
        q3: "Czy martwisz się o niespodziewane awarie?",
        q3Help: "Obawy dotyczące niezawodności",
        q4: "Czy ten samochód jest przeznaczony dla rodziny i na długie podróże?",
        q4Help: "Priorytet bezpieczeństwa i niezawodności",
        factorsTitle: "Czynniki Oceny",
        factorsDesc: "Zobacz, co wpływa na Twoją ocenę",
        newCarComparison: "Porównanie Nowego Samochodu",
        newCarComparisonDesc: "Porównaj swoje obecne miesięczne koszty z zakupem nowego samochodu.",
        modeLeasing: "Leasing",
        modeFullPrice: "Pełna Cena",
        downPayment: "Wpłata Wstępna",
        leaseYears: "Okres (Lata)",
        monthlyPayment: "Miesięczna Płatność",
        carPrice: "Pełna Cena Samochodu",
        ownershipYears: "Planowany Okres Własności (Lata)",
        insuranceMonthly: "Miesięczne CASCO / Ubezpieczenie",
        currentMonthlyCost: "Obecny Koszt Samochodu",
        newCarMonthlyCost: "Koszt Nowego Samochodu",
        newCarCheaper: "Nowy samochód jest tańszy o: {amount} / miesiąc",
        newCarMoreExpensive: "Nowy samochód jest droższy o: {amount} / miesiąc",
        newCarSameCost: "Koszty są dokładnie takie same.",
        advancedSettings: "Ustawienia Zaawansowane",
        yearlyMaint: "Roczne Utrzymanie (€)",
        tyres3Yrs: "Opony / 3 lata (€)",
        depreciation5Yrs: "Amortyzacja (5 lat %)",
        newCarYear: "Rok Nowego Samochodu",
        cumulativeCosts: "Koszty Cumulacyjne (Prognoza)",
        comparisonByYear: "Porównanie Roczne",
        currentCarLabel: "Obecny Samochód",
        newCarLabel: "Nowy Samochód",
        resaleValue: "Wartość odsprzedaży",
        startupCosts: "Koszty początkowe (Używany samochód)",
        inspection: "Inspekcja przedzakupowa",
        initialMaintenance: "Początkowa konserwacja + oleje",
        registration: "Rejestracja / Opłaty",
        total: "Całkowity",
        currentCarTitle: "Aktualny samochód",
        newCarTitle: "Potencjalny samochód",
        upfrontInvestment: "Inwestycja początkowa",
        monthlyReality: "Rzeczywisty miesięczny koszt",
        depreciationShort: "Amortyzacja",
        howCalculated: "Jak to jest obliczane?",
        deltaMonthly: "Miesięczna różnica",
        deltaUpfront: "Różnica początkowa",
        surveyMeanings: {
            practical: {
                1: "Wcale nie",
                2: "Słabe dopasowanie",
                3: "Średnie",
                4: "Dobre dopasowanie",
                5: "Idealne dopasowanie",
            },
            joy: {
                1: "Frustrujące",
                2: "Nudne",
                3: "Średnie",
                4: "Przyjemne",
                5: "Bardzo przyjemne",
            },
            worry: {
                1: "Nie martwię się",
                2: "Trochę się martwię",
                3: "Martwię się",
                4: "Bardzo się martwię",
                5: "Na pewno w każdej chwili się zepsuje",
            },
        },
        verdicts: {
            KEEP: "Finansowo rozsądne, aby zatrzymać",
            borderline: "Na granicy – monitoruj uważnie",
            sell: "Wysokie ryzyko finansowe – sprzedaż może być racjonalna",
        },
        factors: {
            trendInc: "Rosnący Trend",
            trendIncDesc: "Koszty napraw rosną w porównaniu do ubiegłego roku.",
            lowDepreciation: "Zaleta Niskiej Amortyzacji",
            lowDepreciationDesc: "Starsze/tańsze samochody tracą mniej wartości z czasem.",
            stableRepairs: "Stabilne Naprawy",
            stableRepairsDesc: "Twoje koszty napraw są stabilne lub maleją.",
            noHistoricalData: "Brak danych starszych niż 6 miesięcy.",
            lifecycle_stage: "Etap cyklu życia pojazdu",
            high_risk_phase: "Faza wysokiego ryzyka",
            high_risk_phase_desc: "Kombinacja późnego etapu cyklu życia i rosnących kosztów napraw wskazuje na wysokie ryzyko.",
            lowCostKm: "Efektywny Koszt na KM",
            lowCostKmDesc: "Ogólna efektywność eksploatacji tego samochodu jest doskonała.",
            lowFixedCosts: "Niskie Koszty Stałe",
            lowFixedCostsDesc: "Twoje koszty stałe (podatki, ubezpieczenie) są niskie.",
            usage: "Roczne Użytkowanie",
            usageDesc: "Dystans przejechany w ciągu ostatnich 12 miesięcy.",
            accidentMinor: "Drobny Wypadek",
            accidentMinorDesc: "Uszkodzenia kosmetyczne lub małe naprawy.",
            structuralDamage: "Uszkodzenia Strukturalne",
            structuralDamageDesc: "Problemy z ramą lub strukturą drastycznie obniżają wartość.",
            aiLifespanNearEnd: "Koniec Oczekiwanej Żywotności",
            aiLifespanAging: "Starzejące się Komponenty",
            aiLifespanGood: "Zaleta Niskiego Przebiegu",
            aiLifespanDesc: "Na podstawie szacowanej przez AI typowej żywotności dla tego modelu.",
            aiUpcomingRepairs: "Nadchodzące Naprawy (Prognoza AI)",
            aiUpcomingRepairsDesc: "AI przewiduje poważne awarie komponentów wkrótce na podstawie przebiegu.",
            ownershipFatigue: "Zmęczenie posiadaniem",
            ownershipFatigueLong: "Długoterminowe posiadanie często prowadzi do mentalnej gotowości na inny pojazd.",
            ownershipFatigueShort: "Początkowa stronniczość posiadania tworzy silniejszą tendencję do zatrzymania samochodu.",
            family_priority: "Rodzina i Długie Podróże",
            replacement_comparison: "Porównanie Wymiany",
            none: "Brak",
            surface: "Powierzchnia",
            minor: "Drobne",
            moderate: "Umiarkowane",
            severe: "Poważne",
            structural: "Strukturalne",
            major: "Znaczące",
            critical: "Krytyczne",
            full: "Pełne",
            improveLabel: "Co poprawiłoby to:",
            info_original_price: "Przybliżona cena tego samochodu, gdy był nowy. Pomaga oszacować stabilność wartości. Starsze samochody z niższą pozostałą wartością są bezpieczniejsze finansowo.",
            info_current_value: "Ile możesz za niego sprzedać dzisiaj. Używane do sprawdzenia, czy naprawy stanowią dużą część wartości samochodu, co sygnalizuje złe inwestycje.",
            info_yearly_mileage: "Wyższy przebieg zwiększa zużycie. Niski przebieg może znacznie wydłużyć życie samochodu.",
            info_estimated_repairs: "Bieżące koszty utrzymania samochodu w ruchu. Wysokie roczne koszty zmniejszają atrakcyjność posiadania samochodu.",
            info_planned_repairs: "Znane nadchodzące naprawy. Symuluje natychmiastową presję na twoją decyzję.",
            info_ownership_years: "Jak długo posiadasz ten samochód? To wpływa na psychologiczne zmęczenie posiadaniem i początkowe uprzedzenia nabywcy.",
            info_rust: "Krytyczne ryzyko długoterminowe. Rdza strukturalna zmniejsza bezpieczeństwo. Poważna rdza sprawia, że sprzedaż staje się lepszą opcją.",
            info_crashes: "Wypadki strukturalne wpływają na bezpieczeństwo i niezawodność. Zmniejszają również znacząco wartość odsprzedaży.",
            info_repaint: "Sygnalizuje przeszłe uszkodzenia lub kosmetyczne naprawy. Mały wpływ, chyba że ukryte były głębsze problemy.",
            info_unresolved: "Ukryte przyszłe koszty. Znane usterki w elektronice, silniku lub konserwacji, które wymagają uwagi.",
            info_fit: "Czy samochód spełnia twoje potrzeby (przestrzeń, komfort)? Zły dobór oznacza, że jesteś bardziej skłonny do jego wymiany.",
            info_joy: "Wartość emocjonalna ma znaczenie. Brak radości oznacza, że jesteś psychicznie gotowy na nowy samochód.",
            info_worry: "Postrzegany stres związany z niezawodnością. Wysoki poziom zmartwień to silny sygnał do wymiany samochodu.",
        },
        explanations: {
            repairFreq: "Twój samochód miał {visits} wizyt serwisowych w ciągu ostatnich 12 miesięcy. Częste wizyty wskazują na niższą niezawodność i większe niedogodności.",
            repairVsValue: "W ciągu ostatnich 12 miesięcy Twoje naprawy kosztowały €{cost}, podczas gdy szacunkowa wartość samochodu wynosi €{value}. To {ratio}% całkowitej wartości samochodu.",
            stableRepairsDetailYearly: "W zeszłym roku wydałeś €{cost1} na naprawy, ale rok wcześniej €{cost2}. Zmiana o {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "W ciągu ostatnich 6 miesięcy wydałeś €{cost1}, w poprzednich 6 miesiącach €{cost2}. Zmiana o {percent}% ({trend}).",
            mileage: "Przy {mileage} km, samochód wchodzi w wyższą strefę ryzyka poważnych awarii części (skrzynia biegów, komponenty silnika).",
            planned: "Masz €{cost} w planowanych naprawach, co natychmiast obniża finansowe bezpieczeństwo zatrzymania samochodu.",
            lowDep: "Samochody wyceniane na około €{value} tracą bardzo mało wartości rocznie, co równoważy wyższe koszty napraw.",
            depRisk: "Twój samochód ma {age} lat i w większości zakończył cykl amortyzacji, co oznacza, że nie tracisz pieniędzy na spadku jego wartości.",
            stable: "Wydałeś €{costThisYear} w tym roku w porównaniu do €{costLastYear} w ubiegłym roku, co stanowi {percent}% spadek. Przewidywalne koszty są matematycznie korzystne.",
            costKm: "Przejechałeś {km} km w ubiegłym roku. Koszty eksploatacji wyniosły €{costKm} za kilometr, co pokazuje doskonałą efektywność ekonomiczną.",
            fixedCosts: "Zapłaciłeś €{costs} w rocznych kosztach stałych (ubezpieczenie/podatek). Ten niski koszt daje dodatkowy spokój umysłu.",
            usage: "Przejeżdżasz około {km} km rocznie na podstawie swoich zapisów.",
            practical_fit: "Oceniłeś praktyczne dopasowanie na {score}/5, dostosowując matematyczną ocenę o {impact} punktów.",
            emotional_satisfaction: "Oceniłeś swoją satysfakcję emocjonalną na {score}/5, dostosowując ocenę o {impact} punktów.",
            reliability_anxiety: "Twoja pewność co do niezawodności wynosi {score}/5, wpływając na ocenę o {impact} punktów.",
            rust: "Poważna rdza strukturalna lub podwozia zazwyczaj oznacza zagrożenia dla bezpieczeństwa lub scenariusze skasowania.",
            accident: "Poprzednie uszkodzenia, w zależności od ciężkości, z natury obniżają wartość odsprzedaży pojazdu i bezpieczeństwo.",
            structural: "Problemy strukturalne automatycznie czynią samochód finansowo niebezpiecznym.",
            ai_lifespan: "Przy {current} km, samochód zrealizował {ratio}% swojej przewidywanej przez AI żywotności ({expect} km).",
            ai_repairs: "Dane AI wskazują, że przy tej przebiegu zazwyczaj występuje {count} typowych poważnych napraw specyficznych dla modelu.",
            lifecycle_stage: "Co oznacza żywotność? {total} km – to punkt przewidywany przez AI, w którym zazwyczaj zaczynają się poważne naprawy strukturalne (silnik, skrzynia biegów itp.) dla tego modelu. To nie koniec życia samochodu – samochód nadal może jeździć, ale z znacznie wyższymi kosztami utrzymania. Typowa pełna fizyczna żywotność samochodu wynosi 500k–1M km, ale staje się ekonomicznie nieopłacalna znacznie wcześniej.",
        },
        ratios: {
            healthy: "Zdrowy",
            monitor: "Monitoruj",
            highRisk: "Wysokie ryzyko",
            stable: "Stabilny",
            warning: "Ostrzeżenie",
            financialStress: "Stres finansowy",
        },
        proFeatureTitle: "Funkcja Pro: Tryb Naprawy",
        proFeatureDesc: "Odblokuj silnik decyzyjny, aby uzyskać profesjonalną analizę finansową napraw Twojego pojazdu. Użytkownicy darmowi widzą demonstrację z danymi przykładowymi.",
        viewDemo: "Zobacz na żywo",
        upgradeToUnlock: "Ulepsz do PRO, aby analizować swój samochód",
    },
    carTasks: {
        title: "Zadania Samochodowe",
        placeholderTitle: "Śledzenie Utrzymania",
        placeholderDesc: "Harmonogram utrzymania dla Twojego modelu samochodu.",
        demoTitle: "Zadania Utrzymania Samochodu",
        demoSubtitle: "Inteligentne śledzenie Twojego pojazdu",
        feature1Title: "Automatyczne Generowanie Zadań",
        feature1Desc: "Automatycznie generuje zadania takie jak wymiana oleju, wymiana filtrów i kontrola paska rozrządu na podstawie modelu Twojego samochodu.",
        feature2Title: "Integracja Wydatków",
        feature2Desc: "Analizuje historię serwisową, aby zrozumieć, co już zostało zrobione i kiedy.",
        feature3Title: "Inteligentne Przypomnienia",
        feature3Desc: "Otrzymuj powiadomienia na podstawie zarówno czasu, jak i przebiegu. Śledzenie resetuje się automatycznie, gdy oznaczysz zadanie jako wykonane.",
        getStarted: "Rozpocznij",
        fakeDoorPopupTitle: "Opinie Mile Widziane",
        fakeDoorPopupMessage: "Obecnie rozwijamy zadania związane z utrzymaniem samochodu. Ta funkcja pozwoli Ci automatycznie śledzić interwały serwisowe. Jakie konkretne zadania lub funkcje chciałbyś zobaczyć najbardziej?",
        fakeDoorPopupPlaceholder: "Twoje myśli...",
        noTasksYet: "Brak zadań",
        deleteAllTitle: "Czy wyczyścić listę zadań?",
        deleteAllMessage: "Czy na pewno chcesz usunąć wszystkie {count} zadań dla tego samochodu? Ta akcja nie może być cofnięta.",
        deleteAllSuccess: "Wszystkie zadania zostały pomyślnie usunięte.",
        sortPriority: "Priorytet",
        sortType: "Typ",
        sortDate: "Najnowsze",
        status: {
            overdue: "ZAAWANSOWANE",
            pending: "OCZEKUJĄCE",
            noData: "BRAK DANYCH",
            upcoming: "Nadchodzące",
            nextIn: "Następne za {dist} {unit}",
            overdueBy: "Zaległe o {dist} {unit}",
            afterDays: "Za {days} dni",
            overdueDays: "Zaległe o {days} dni",
        },
        form: {
            newTitle: "Nowe Zadanie",
            actionType: "Inspekcja czy Wymiana?",
            intervalMonths: "Interwał (Miesiące)",
            intervalDistance: "Interwał (Odległość)",
            diffFirstInterval: "Pierwszy interwał różni się od podstawowego interwału",
            firstInterval: "Pierwszy Interwał",
            historyToggle: "Czy to zadanie kiedykolwiek było wykonane dla tego samochodu?",
            historyToggleDesc: "Jeśli NIE, zakładamy, że nigdy nie było wykonane od momentu produkcji.",
            lastPerformedOptional: "Kiedy było ostatnio wykonane? (Opcjonalnie)",
            deleteTitle: "Usuń Zadanie",
            deleteConfirm: "Czy na pewno chcesz usunąć to zadanie?",
            saveError: "Nie udało się zapisać zadania",
            historyConfirmed: "Historia Potwierdzona",
            reminders: "Przypomnienia",
            notifyMileage: "Powiadom mnie, gdy osiągnę przewidywany przebieg",
            notifyDate: "Powiadom mnie, gdy osiągnę datę",
            nextMileageReminder: "Przewidywana data",
            nextDateReminder: "Termin",
            estimatedDate: "Szacowana data",
            missingLastMileage: "Brak ostatniego przebiegu",
            missingLastDate: "Brak ostatniej daty",
            missingStartDate: "Nie można określić daty rozpoczęcia",
            additionalOptions: "Dodatkowe opcje",
            reminderInfoMissing: "Stan informacyjny: przypomnienia są wyłączone, dopóki nie zostaną podane ostatnie wykonane dane.",
        },
    },
    dashboard: {
        title: "Panel",
        quickActions: "Szybkie działania",
        addExpense: "Dodaj wydatek",
        editCar: "Edytuj samochód",
        recentExpenses: "Wydatki",
        seeAll: "Zobacz wszystko",
        recentGallery: "Pliki",
        thisMonth: "Ten miesiąc",
        totalSpent: "Łącznie wydane",
        avgPerMonth: "Średnio/miesiąc",
        recentNotes: "Notatki",
        recentParts: "Części",
        noRecentExpenses: "Brak ostatnich wydatków",
        noRecentGallery: "Brak ostatnich zdjęć",
        noRecentNotes: "Brak ostatnich notatek",
        noRecentParts: "Brak ostatnich części",
        createNote: "Utwórz nową",
        createPart: "Utwórz nową",
        createExpense: "Utwórz nowy",
        noFiles: "Brak dodanych plików",
        needSomethingMore: "Potrzebujesz czegoś więcej?",
        letUsKnow: "daj nam znać!",
    },
    expenseTypes: {
        editTitle: "Edytuj typ wydatku",
        newTitle: "Nowy typ wydatku",
        categoryName: "Nazwa kategorii",
        placeholderName: "np. Serwis",
        signatureColor: "Kolor podpisu",
        icon: "Ikona kategorii",
        deleteConfirm: "Czy na pewno chcesz usunąć typ '{name}'?",
    },
    spareParts: {
        title: "Części zamienne",
        connectedWithRecords: "Połączone z Rekordami",
        toBuy: "Do kupienia",
        usedInExpenses: "Używane w wydatkach",
        noPartsToBuy: "Brak części dodanych do listy zakupów",
        noPartsUsed: "Brak części powiązanych z wydatkami",
        quantity: "Ilość",
        partCode: "Kod części",
        price: "Cena",
        link: "Link",
        comment: "Komentarz",
        addPart: "Dodaj część zamienną",
        editPart: "Edytuj część zamienną",
        openPart: "Otwórz wpis części",
        nameLabel: "Nazwa",
        manufacturerLabel: "Producent",
        priceLabel: "Cena ({currency})",
        imagesLabel: "Pliki",
        linkedHistory: "Powiązana historia",
        partManagedNote: "Ta część jest zarządzana przez wydatek",
        cannotDeleteNote: "Ponieważ ta część jest powiązana z wydatkiem, nie można jej usunąć osobno. Usuń lub edytuj wydatek, aby zarządzać cyklem życia tej części.",
        partNamePlaceholder: "Nazwa części...",
        manufacturerPlaceholder: "Bosch, Brembo, itd.",
        additionalInfoPlaceholder: "Dodatkowe informacje...",
        namePlaceholder: "np. Klocki hamulcowe",
        codePlaceholder: "np. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Zapisz część",
        deletePart: "Usuń część zamienną",
        deleteConfirm: "Czy na pewno chcesz usunąć tę część zamienną?",
        sparePartsLabel: "Części zamienne",
        partNumber: "Część #{number}",
        imagesLimitLabel: "Pliki (do 5)",
        optional: "(opcjonalne)",
        selectPart: "Wybierz część zamienną",
        createNew: "Utwórz nową część zamienną",
        searchPlaceholder: "Szukaj po nazwie lub kodzie...",
        noResults: "Nie znaleziono części",
        noPartsYet: "Brak części. Utwórz swoją pierwszą!",
        selectorDescription: "Znajdź i wybierz istniejącą część zamienną lub utwórz nową",
        alreadyAdded: "Ta część jest już dodana",
        statistics: {
            avgPrice: "Średnia",
            lastPrice: "Ostatnia",
            usedTimes: "Używana {count} razy",
            totalPurchased: "Łącznie: {quantity}x",
        },
        usage: {
            title: "Ten zakup",
            quantity: "Ilość",
            pricePerUnit: "Cena za jednostkę",
            comment: "Komentarz",
            commentPlaceholder: "np. Kupione w AutoZone",
            total: "Łącznie",
            transactionData: "Ta Transakcja",
        },
        masterData: "Informacje o Głównych Częściach",
        masterRecord: {
            title: "Szczegóły części (wspólne)",
            editMaster: "Edytuj rekord główny",
            warning: "Zmiany w rekordzie głównym wpływają na wszystkie użycia",
        },
    },
    reminders: {
        title: "Przypomnienia",
        reminder: "Przypomnienie",
        noteReminder: "Przypomnienie o notatce",
        partReminder: "Przypomnienie o części",
        today: "Dziś",
        tomorrow: "Jutro",
        yesterday: "Wczoraj",
        inXDays: "za {x} dni",
        xDaysAgo: "{x} dni temu",
        inXMonths: "za {x} miesięcy",
        xMonthsAgo: "{x} miesięcy temu",
        active: "Aktywne",
        activeDesc: "W razie potrzeby możesz wyłączyć to przypomnienie bez jego usuwania",
        disabled: "Wyłączone",
        yearly: "Roczne",
        markSeen: "Potwierdź",
        addReminder: "Nowe przypomnienie",
        editReminder: "Edytuj przypomnienie",
        extraReminders: "Dodatkowe przypomnienia",
        extraRemindersDesc: "Wyślij 3 dodatkowe przypomnienia w następujące dni (łącznie 4), jeśli nie zostaną zatrzymane.",
        remindDate: "Data",
        remindTime: "Czas",
        repeatYearly: "Powtarzaj rocznie",
        repeatYearlyDesc: "To przypomnienie będzie automatycznie występować co roku w tej samej dacie/miesiącu/dniu/czasie, aż do wyłączenia",
        standalone: "Samodzielne przypomnienia",
        embedded: "Powiązane przypomnienia",
        noReminders: "Brak aktywnych przypomnień",
        deleteReminder: "Usuń przypomnienie",
        nameLabel: "Nazwa",
        descriptionLabel: "Opis",
        namePlaceholder: "Nazwa przypomnienia",
        descriptionPlaceholder: "Krótki opis lub notatka",
        simulateReminder: "Symuluj moment przypomnienia",
        simulateSuccess: "E-mail symulacyjny wysłany",
        timezone: "Strefa czasowa",
        nextReminder: "Następne przypomnienie",
        futureTimeError: "Czas przypomnienia musi być w przyszłości",
    },
    notes: {
        title: "Notatki",
        emptyNote: "Pusta notatka",
        noNotes: "Brak notatek",
        addNote: "Dodaj notatkę",
        editNote: "Edytuj notatkę",
        viewNote: "Zobacz notatkę",
        openNote: "Otwórz wpis notatki",
        titleLabel: "Tytuł",
        contentLabel: "Treść",
        noteTitlePlaceholder: "Tytuł notatki...",
        noteContentPlaceholder: "Napisz swoją notatkę tutaj...",
        saveNote: "Zapisz notatkę",
        deleteNote: "Usuń notatkę",
        publicNote: "Uczyń notatkę publiczną",
        publicNoteDesc: "Inni mogą zobaczyć tę notatkę za pomocą udostępnionego linku",
        deleteConfirm: "Czy na pewno chcesz usunąć tę notatkę?",
        enterTitleAlert: "Proszę wpisać tytuł",
        saveFailed: "Nie udało się zapisać notatki",
        thisNote: "Ta notatka",
        deleteFailed: "Nie udało się usunąć notatki",
        pinToTop: "Przypnij na górze",
    },
    locations: {
        title: "Lokalizacje",
        singleTitle: "Lokalizacja",
        newLocation: "Nowa lokalizacja",
        emptyLocation: "Pusta lokalizacja",
        noLocations: "Dla statystyk - możesz dodać lokalizację, w której wystąpił ten wydatek samochodowy",
        addLocation: "Dodaj lokalizację",
        editLocation: "Edytuj lokalizację",
        viewLocation: "Zobacz lokalizację",
        openLocation: "Otwórz lokalizację",
        createNew: "Utwórz nową lokalizację",
        selectLocation: "Wybierz lokalizację",
        searchLocations: "Szukaj lokalizacji...",
        nameLabel: "Nazwa",
        addressLabel: "Adres lub Współrzędne",
        descriptionLabel: "Komentarz/Opis",
        namePlaceholder: "np. Serwis w Centrum",
        mapLabel: "Lokalizacja",
        searchPlaceholder: "Szukaj adresu...",
        addressPlaceholder: "Wprowadź adres i wybierz...",
        descriptionPlaceholder: "Dodatkowe informacje...",
        fillAddress: "Uzupełnij adres z mapy",
        saveLocation: "Zapisz lokalizację",
        deleteLocation: "Usuń lokalizację",
        deleteConfirm: "Czy na pewno chcesz usunąć tę lokalizację?",
        enterNameAlert: "Proszę wpisać nazwę",
        saveFailed: "Nie udało się zapisać lokalizacji",
        thisLocation: "Ta lokalizacja",
        deleteFailed: "Nie udało się usunąć lokalizacji",
        myLocations: "Moje lokalizacje",
        usedInEntries: "Używane w wpisach",
        noEntries: "Lokalizacja nie jest używana",
        noEntriesThisCar: "Ta lokalizacja nie była używana dla tego samochodu",
        removeLocation: "Usuń lokalizację",
        noResults: "Nie znaleziono wyników",
    },
    gallery: {
        title: "Pliki",
        noImages: "Nie dodano żadnych obrazów",
        addImagesNote: "Dodaj obrazy do samochodu lub wydatków",
        totalImages: "Łącznie {count} obrazów",
        imageAlt: "Obraz {number}",
        commentPlaceholder: "Komentarz do pliku",
        isReceipt: "Ten plik jest paragonem",
        deleteImageTitle: "Usuń plik",
        deleteImageConfirm: "Czy na pewno chcesz na stałe usunąć ten plik?",
    },
    search: {
        placeholder: "Szukaj wydatków, części, notatek...",
        typeToSearch: "Wpisz, aby rozpocząć wyszukiwanie",
        noResults: "Nie znaleziono wyników dla '{query}'",
        carImage: "Obraz samochodu",
        expenseImage: "Obraz wydatku",
        noteImage: "Obraz notatki",
        galleryImage: "Obraz galerii",
        untitledExpense: "Nieopisana wydatki",
    },
    landing: {
        nav: {
            features: "Funkcje",
            howItWorks: "Jak to działa",
            pricing: "Cennik",
            login: "Zaloguj się",
            getStarted: "Zacznij",
            garage: "Garaż",
        },
        hero: {
            title: "Wiedź dokładnie, ile kosztuje Twój samochód",
            subtitle: "Naprawdę",
            description: "Śledź wydatki, rejestruj naprawy i zobacz, gdzie naprawdę trafiają Twoje pieniądze.",
            subheadline: "Profesjonalny pulpit nawigacyjny oparty na danych dla skrupulatnych właścicieli samochodów.",
            startTracking: "Zacznij",
            viewDemo: "Demo Samochodu ->",
            trustSignal: "Dołącz do 1,200+ skrupulatnych właścicieli, którzy już zmapowali ponad 5 milionów kilometrów rzeczywistych kosztów samochodowych.",
            ctaNote: "Brak karty kredytowej. Brak nachalnej sprzedaży. Tylko przejrzystość.",
            benefits: {
                repairVsSell: {
                    title: `Naprawa vs. Sprzedaż`,
                    description: `Zidentyfikuj próg "Naprawa vs. Sprzedaż" — Przestań się zastanawiać, czy inwestujesz pieniądze w studnię bez dna. Poznaj dokładny moment, w którym naprawa przestaje być mądrym inwestycją.`
                },
                costPerKm: {
                    title: `Koszt na KM`,
                    description: `Śledź swój rzeczywisty koszt na kilometr — Wyjdź poza pulpit nawigacyjny. Zobacz pełny obraz finansowy swoich nawyków jazdy, którego inne aplikacje nie uwzględniają.`
                },
                automation: {
                    title: `Automatyzacja`,
                    description: `Zautomatyzuj swoje prowadzenie rejestrów — Po prostu przekaż swoje faktury lub po prostu wyślij swoje notatki mailem. Nasza AI organizuje historię techniczną Twojego samochodu za Ciebie.`
                }
            },
        },
        features: {
            title: "Wszystko, czego potrzebujesz do zarządzania swoim samochodem",
            subtitle: "Przestań używać arkuszy kalkulacyjnych i bałaganu w folderach. My Car Costs przynosi profesjonalne narzędzia do zarządzania flotą do twojego osobistego garażu.",
            expenseTracking: {
                title: "Śledzenie wydatków",
                description: "Rejestruj paliwo, serwis, ubezpieczenie i naprawy. Kategoryzuj koszty i wizualizuj trendy wydatków w czasie.",
            },
            spareParts: {
                title: "Zarządzanie częściami zamiennymi",
                description: "Utrzymuj szczegółowy spis części zamiennych, numerów części i notatek o kompatybilności dla wszystkich swoich napraw.",
            },
            serviceHistory: {
                title: "Historia serwisowa i notatki",
                description: "Utrzymuj cyfrową książkę serwisową. Dodawaj szczegółowe notatki o konserwacji, modyfikacjach lub przyszłych planach.",
            },
            documentStorage: {
                title: "Przechowywanie dokumentów",
                description: "Prześlij paragony, faktury i zdjęcia swojego samochodu. Przechowuj wszystkie swoje dokumenty w bezpiecznym i dostępnym miejscu.",
            },
            emailForwarding: {
                title: "Przekazywanie e-maili",
                description: "Przekazuj faktury bezpośrednio do swojej unikalnej skrzynki odbiorczej. Wyciągniemy dane i automatycznie dodamy je do twojego pulpitu.",
            },
            multiCar: {
                title: "Garaż wieloautowy",
                description: "Zarządzaj jednym samochodem lub całą flotą. Przełączaj się między pojazdami w mgnieniu oka i zobacz skumulowane statystyki.",
            },
            repeatingExpenses: {
                title: "Powtarzające się wydatki",
                description: "Zautomatyzuj śledzenie regularnych miesięcznych kosztów, takich jak ubezpieczenie, parking czy leasing.",
            },
            smartReminders: {
                title: "Inteligentne przypomnienia",
                description: "Ustaw niestandardowe powiadomienia dla części zamiennych i notatek serwisowych, aby nigdy nie przegapić zadania konserwacyjnego.",
            },
        },
        howItWorks: {
            title: "Prosty, potężny proces",
            step1: {
                title: "Dodaj swój pojazd",
                description: "Wprowadź szczegóły swojego samochodu, aby utworzyć swój cyfrowy garaż.",
            },
            step2: {
                title: "Rejestruj wydatki i pliki",
                description: "Zrób zdjęcie paragonu lub przekaż e-mail. My zajmiemy się resztą.",
            },
            step3: {
                title: "Uzyskaj wgląd",
                description: "Zobacz swoje koszty na kilometr, miesięczne wydatki i harmonogram konserwacji.",
            },
        },
        useCases: {
            title: "Idealne dla",
            enthusiasts: {
                title: "Entuzjaści samochodów",
                description: "Śledź każdą modyfikację, numer części i interwał konserwacji dla swojego samochodu projektowego.",
            },
            dailyDrivers: {
                title: "Codzienni kierowcy",
                description: "Wiedź dokładnie, ile kosztuje twój dojazd i nigdy nie przegap daty serwisu.",
            },
            flippers: {
                title: "Inteligentny Flipper",
                description: "Zbuduj weryfikowalną ilość danych, które udowodnią prawdziwą wartość Twojego samochodu dla kupujących.",
            },
            fleets: {
                title: "Małe floty",
                description: "Zarządzaj wieloma pojazdami firmowymi w jednym miejscu bez zbędnego oprogramowania korporacyjnego.",
            },
        },
        foundersNote: {
            title: "Notatka założyciela",
            content: "Buduję MyCarCosts, aby był ostatecznym narzędziem dla ludzi, którzy naprawdę dbają o swoje samochody. Czy brakuje jakiejś funkcji w Twoim workflow? Skontaktuj się ze mną bezpośrednio. Jeśli ma to sens dla społeczności, zbudujemy to razem.",
        },
        pricing: {
            freeLimitedTime: "Darmowe przez ograniczony czas",
            title: "Prosty, przejrzysty cennik",
            subtitle: "Zacznij za darmo, rozwijaj się w miarę wzrostu.",
            perMonth: "miesiąc",
            monthly: "Miesięcznie",
            yearly: "Rocznie",
            save25: "Zaoszczędź 25%",
            billedAnnually: "Fakturowane rocznie ({amount})",
            free: {
                title: "Darmowy",
                cta: "Rozpocznij",
            },
            pro: {
                title: "Pro",
                cta: "Przejdź na Pro",
                recommended: "Zalecane",
                earlyAdopter: "Ceny dla wczesnych użytkowników",
                priceLock: "Zablokuj tę cenę teraz. Cena może wzrosnąć w przyszłości.",
            },
            custom: {
                title: "Custom",
                cta: "Skontaktuj się z nami",
            },
            features: {
                oneCar: "1 samochód",
                unlimitedExpenses: "Nieograniczone wydatki",
                unlimitedSpareParts: "Nieograniczone części zamienne",
                unlimitedNotes: "Nieograniczone notatki",
                repeatedExpenses: "Powtarzające się wydatki",
                emailReminders: "Przypomnienia e-mailowe o notatkach i częściach zamiennych",
                basicStatistics: "Podstawowe statystyki",
                fullStatistics: "Pełne statystyki",
                storage50mb: "50 Mb pamięci na pliki",
                unlimitedArchivedCars: "Nieograniczone archiwizowane samochody",
                dataExport: "Eksport danych",
                allInFreePlus: "wszystko w darmowym plus:",
                threeCars: "Do 3 samochodów",
                storage2gb: "2 Gb pamięci na pliki",
                emailParsing: "Analiza e-maili",
                carAdmins: "Administratorzy samochodów",
                moreCars: "Więcej samochodów",
                moreFileStorage: "Więcej pamięci na pliki",
                customRequirements: "Wymagania niestandardowe",
            },
            upgradePopup: {
                title: "Już wkrótce!",
                message: "Wersje pro i niestandardowe nie zostały jeszcze uruchomione, ale będą wkrótce. Aby pomóc nam w szybszym uruchomieniu - prosimy o zapisanie, jakiej konkretnej funkcji oczekujesz od wersji pro / niestandardowej lub czegokolwiek innego, co chciałbyś, abyśmy poprawili, aby ta platforma była jeszcze lepsza dla Ciebie!",
                placeholder: "Napisz swoją opinię tutaj...",
                submit: "Wyślij",
                cancel: "Anuluj",
                thanksTitle: "Dziękujemy!",
                thanksMessage: "Otrzymaliśmy Twoją opinię i będziemy pracować nad tym, aby MyCarCosts było jeszcze lepsze!",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "Przechodzisz z Excela lub innej aplikacji?",
            subtitle: "Oferujemy profesjonalną usługę migracji danych, abyś mógł szybko zacząć.",
            pricingModel: "Model cenowy",
            small: {
                title: "Mały zestaw danych",
                description: "< 500 wierszy",
                price: "19–29 zł",
            },
            medium: {
                title: "Średni zestaw danych",
                description: "500–5,000 wierszy",
                price: "49 zł",
            },
            large: {
                title: "Duży / Złożony",
                description: "Systemy legacy lub złożone pliki",
                price: "Indywidualna wycena",
            },
            process: {
                title: "Jak to działa",
                step1: "Przesyłasz swój plik",
                step2: "Oceniamy dane",
                step3: "Jednorazowa płatność",
                step4: "Zajmujemy się importem",
            },
            cta: "Złóż wniosek o migrację",
        },
        repairAnalysisSection: {
            title: "Naprawić czy sprzedać? Niech dane zdecydują.",
            subtitle: "Profesjonalna analiza finansowa dla Twojego pojazdu. Przestań zgadywać i zacznij wiedzieć, czy te naprawy są naprawdę warte zachodu.",
            features: {
                personalized: {
                    title: "Spersonalizowana analiza",
                    description: "Dla Twoich śledzonych samochodów wykorzystujemy rzeczywiste historyczne wydatki i parametry, dodając planowane koszty, aby wygenerować ocenę.",
                },
                public: {
                    title: "Publiczny symulator",
                    description: "Ocenić potencjalny zakup? Użyj naszego publicznego narzędzia na /repair, aby wygenerować szczegółową analizę, wprowadzając tylko kilka kluczowych szczegółów.",
                },
                whatIf: {
                    title: "Symulator Co-Jeśli",
                    description: "Wprowadź planowany koszt naprawy i natychmiast zobacz, jak wpływa to na finansowy wynik Twojego samochodu.",
                },
            },
            cta: "Zobacz przykładową analizę",
        },
        faq: {
            title: "Najczęściej Zadawane Pytania",
            subtitle: "Wszystko, co musisz wiedzieć o My Car Costs",
            questions: {
                mobileApps: {
                    question: "Czy będą aplikacje na iOS i Android?",
                    answer: "Tak! Aplikacje mobilne na iOS i Android wkrótce będą dostępne. Pracujemy ciężko, aby zapewnić Ci najlepsze doświadczenie mobilne.",
                },
                dataPrivacy: {
                    question: "Czy moje dane są prywatne i bezpieczne?",
                    answer: "Absolutnie. Twoje dane są szyfrowane i przechowywane w bezpieczny sposób. Tylko Ty masz dostęp do informacji o swoim samochodzie, chyba że wyraźnie zdecydujesz się je udostępnić.",
                },
                freePlan: {
                    question: "Czy darmowy plan jest naprawdę darmowy na zawsze?",
                    answer: "Tak! Darmowy plan zawsze będzie dostępny dla jednego samochodu i wszystkich niezbędnych funkcji. Możesz przejść na Pro w dowolnym momencie dla maksymalnie 3 samochodów i zaawansowanych funkcji.",
                },
                dataExport: {
                    question: "Czy mogę eksportować moje dane?",
                    answer: "Tak, możesz eksportować wszystkie swoje dane w dowolnym momencie w formacie CSV lub PDF. Twoje dane są Twoje, nigdy nie jesteś związany.",
                },
                emailImport: {
                    question: "Jak działa import e-maili?",
                    answer: "Każdy samochód ma unikalny adres e-mail. Po prostu przekaż swoje faktury, a my automatycznie wydobędziemy dane.",
                },
                multipleUsers: {
                    question: "Czy wiele osób może uzyskać dostęp do tego samego samochodu?",
                    answer: "Obecnie każdy samochód należy do jednego konta. Możesz jednak uczynić samochód publicznie dostępnym, aby udostępnić dostęp tylko do odczytu innym.",
                },
            },
        },
        cta: {
            title: "Przestań zgadywać. Zacznij wiedzieć.",
            subtitle: "Zamień historię swojego auta w jasne decyzje finansowe. Dołącz do tysięcy mądrych właścicieli, którzy wiedzą dokładnie, kiedy inwestować, a kiedy sprzedać.",
            button: "Rozpocznij teraz",
            note: "Brak karty kredytowej. Brak nachalnej sprzedaży. Tylko przejrzystość.",
        },
        footer: {
            product: "Produkt",
            legal: "Prawne",
            changelog: "Historia zmian",
            privacy: "Polityka prywatności",
            contact: "Kontakt",
            contactEmail: "info@mycarcosts.com",
            questions: "Masz pytania? Skontaktuj się z nami pod adresem:",
        },
        privacy: {
            title: "Polityka prywatności",
            lastUpdated: "Ostatnia aktualizacja: 25 marca 2026",
            introduction: "W My Car Costs traktujemy Twoją prywatność poważnie. Niniejsza polityka wyjaśnia, w jaki sposób obchodzimy się z Twoimi danymi.",
            dataCollection: {
                title: "Zbieranie Danych",
                description: "Zbieramy tylko absolutnie minimalne informacje potrzebne do świadczenia naszej usługi.",
                email: "Tożsamość Konta: Używamy Twojego adresu e-mail jako unikalnego identyfikatora oraz do autoryzacji (np. magiczne linki lub logowanie przez Google).",
                documents: "Przechowywanie Dokumentów: Pliki, które przesyłasz, są przechowywane bezpiecznie w zaszyfrowanej chmurze.",
            },
            carData: {
                title: "Kontrola Twoich Danych",
                description: "Informacje, które wprowadzasz (wydatki, przebieg, części) są przechowywane do Twojego osobistego użytku i analizy.",
                noValidation: "Nie weryfikujemy danych samochodu, które podajesz; to Twoja odpowiedzialność, aby zapewnić ich dokładność.",
                privateByDefault: "Domyślnie Twoje dane są prywatne. Identyfikatory techniczne dla plików są nieliniowe i nie są indeksowane przez wyszukiwarki.",
                rightToForgotten: "Prawo do bycia zapomnianym: Możesz usunąć swoje konto w dowolnym momencie, co natychmiastowo i trwale usuwa wszystkie Twoje rekordy i pliki.",
            },
            thirdParty: {
                title: "Usługi stron trzecich",
                description: "Nie sprzedajemy Twoich danych osobowych. Korzystając z logowania przez Google, uzyskujemy dostęp jedynie do Twojego adresu e-mail w celach identyfikacyjnych.",
            },
            emailIngestion: {
                title: "Przetwarzanie wiadomości e-mail",
                description: "Wiadomości e-mail wysyłane do naszej usługi są przechowywane w celu zapewnienia historii przetwarzania. Możesz w dowolnym momencie ręcznie usunąć poszczególne wiadomości lub całą historię.",
            },
        },
        emails: {
            deleteAll: "Usuń wszystko",
            deleteAllConfirm: "Czy na pewno chcesz usunąć całą historię e-mail dla tego samochodu? Ta operacja jest nieodwracalna.",
            deleteConfirm: "Czy na pewno chcesz usunąć tę wiadomość?",
            noEmails: "Nie otrzymano jeszcze żadnych wiadomości e-mail.",
        },
        terms: {
            title: "Regulamin",
            lastUpdated: "Ostatnia aktualizacja: 25 marca 2026",
            introduction: "Uzyskując dostęp do MyCarCosts lub korzystając z serwisu, wyrażasz zgodę na przestrzeganie niniejszego Regulaminu. Jeśli nie wyrażasz zgody, prosimy o niekorzystanie z naszej usługi.",
            acceptance: {
                title: "1. Akceptacja Warunków",
                description: "Niniejsze warunki stanowią prawnie wiążącą umowę między Tobą a MyCarCosts dotyczącą korzystania z naszej aplikacji i usług.",
            },
            service: {
                title: "2. Opis Usługi",
                description: "MyCarCosts udostępnia platformę do śledzenia wydatków na pojazdy, zarządzania konserwacją i analizy finansowej. Obejmuje to analizę paragonów wspomaganą przez AI oraz narzędzia do wizualizacji danych.",
            },
            responsibilities: {
                title: "3. Odpowiedzialność Użytkownika",
                description: "Odpowiadasz za rzetelność wszystkich wprowadzanych danych, w tym przebiegu, numerów VIN i kosztów. Musisz dbać o bezpieczeństwo swoich danych logowania (e-mail/magic link) i nie udostępniać ich nieuprawnionym osobom.",
            },
            plans: {
                title: "4. Plany Usług i Limity",
                description: "Oferujemy plany Darmowy i Pro z różnymi limitami miejsca, liczby samochodów i przesyłanych plików. Zastrzegamy sobie prawo do zmiany tych limitów lub wprowadzania nowych poziomów subskrypcji w dowolnym momencie.",
            },
            disclaimer: {
                title: "5. Wyłączenie Odpowiedzialności i Rzetelność",
                description: "MyCarCosts jest narzędziem informacyjnym i organizacyjnym. Nie wystawiamy oficjalnych certyfikatów stanu technicznego pojazdu. Dane z paragonów analizowane przez AI powinny być zawsze sprawdzane przez użytkownika pod kątem poprawności.",
            },
            liability: {
                title: "6. Ograniczenie Odpowiedzialności",
                description: "Usługa MyCarCosts jest świadczona w stanie, w jakim się znajduje ('as-is'). Nie ponosimy odpowiedzialności za jakiekolwiek problemy mechaniczne, straty finansowe ani nieścisłości w danych wynikające z korzystania z naszej aplikacji.",
            },
            termination: {
                title: "7. Rozwiązanie Umowy",
                description: "Możesz w dowolnym momencie przestać korzystać z usługi i usunąć swoje dane. Zastrzegamy sobie prawo do zawieszenia lub zamknięcia kont, które naruszają niniejsze warunki lub wykazują nadużycia.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

